
export const swiperTab = {
    ABOUT_US: 1,
    AGENT: 2,
    COMMUNITY: 3,
    NEWS: 4,
    APP: 5,
    ROADMAP: 6,
    NETWORK: 7,
    EDISON: 8,
}

export const swiperMobileTab = {
    HOME: "banner",
    ABOUT_US: "about",
    AGENT: "agent",
    COMMUNITY: "community",
    NEWS: "news",
    APP: "app",
    ROADMAP: "roadMap",
    NETWORK: "network",
    EDISON: "foundation",
}

export const IND_STR_TYPE = "indicator"

export const PYTHAGORAS_TYPE = "pythagoras"

export const PUB_PATH = true

export const SCROLL_V = true

const DEFAULT_ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp"];


/* token decode */

function decodeBase64Url(base64Url) {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    try {
        const decoded = atob(base64);
        return JSON.parse(decoded);
    } catch {
        return null;
    }
}

export function decodeJWT(token) {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) {
        return null;
    }
    const header = decodeBase64Url(parts[0]);
    const payload = decodeBase64Url(parts[1]);
    if (!header || !payload) return null;
    return { header, payload };
}


/* ai content updated */

const normalizeListFormatting = (text) => {
    if (!text) return '';

    let normalized = text;

    normalized = normalized.replace(/(?<!^)(?<!\n)(\s)(\d{1,2}\.\s)/g, '\n$2');

    normalized = normalized.replace(/(?<!^)(?<!\n)(\s)(-\s)(?=[A-Z])/g, '\n$2');

    return normalized;
};

export const cleanMessageText = (text) => {
    if (!text) return '';

    let cleaned = String(text).trim();

    if (
        (cleaned.startsWith('"') && cleaned.endsWith('"')) ||
        (cleaned.startsWith("'") && cleaned.endsWith("'"))
    ) {
        cleaned = cleaned.slice(1, -1);
    }

    cleaned = cleaned
        .replace(/\\n/g, '\n')
        .replace(/\\t/g, '\t')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");

    cleaned = normalizeListFormatting(cleaned);

    return cleaned;
};

export const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const dateOptions = {
        month: "short",
        day: "2-digit",
        year: "numeric",
        timeZone: "Europe/Rome",
    };
    const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Europe/Rome",
    };
    return (
        date.toLocaleDateString("en-US", dateOptions) +
        " " +
        date.toLocaleTimeString("en-US", timeOptions)
    );
};

const parseUtcDate = (dateStr) => {
    const m = dateStr.match(
        /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/
    );
    if (!m) return new Date(dateStr);

    const [, y, mo, d, h, mi, s] = m.map(Number);
    return new Date(Date.UTC(y, mo - 1, d, h, mi, s));
};

export const formatUtcToLocalDate = (dateStr) => {
    if (!dateStr) return "";

    const date = parseUtcDate(dateStr);
    if (isNaN(date.getTime())) return "";

    return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};


const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const italyTime = () => {
    const italy = new Date().toLocaleString("sv-SE", {
        timeZone: "Europe/Rome",
    });

    const date = new Date(italy);

    const result = `${days[date.getDay()]}, ${String(date.getDate()).padStart(2, "0")} ${months[date.getMonth()]
        } ${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(
            date.getMinutes()
        ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")} GMT`;

    return result

}




export const getExtension = (file) => file?.name?.split(".").pop()?.toLowerCase() ?? "";

export const isImageFile = (file) =>
    file?.type?.startsWith("image/") || IMAGE_EXTENSIONS.includes(getExtension(file));

export const readFileAsync = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
    });

const readImageDimensions = (dataUrl) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({ width: img.width, height: img.height });
        img.onerror = () => reject(new Error("dimension-read-failed"));
        img.src = dataUrl;
    });


export async function validateFile(file, rules = {}) {
    const {
        allowedExtensions = DEFAULT_ALLOWED_EXTENSIONS,
        maxSizeMB = 5,
        checkImageDimensions = false,
        maxDimension = 6000,
        generatePreview = false,
    } = rules;

    if (!file) return { ok: false, message: "No file selected." };

    const ext = getExtension(file);
    if (allowedExtensions.length && !allowedExtensions.includes(ext)) {
        return { ok: false, message: `Only ${allowedExtensions.join(", ").toUpperCase()} files are allowed.` };
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
        return { ok: false, message: `File is too large. Max size is ${maxSizeMB}MB.` };
    }

    if (!isImageFile(file) || (!checkImageDimensions && !generatePreview)) {
        return { ok: true, previewUrl: null };
    }

    let dataUrl;
    try {
        dataUrl = await readFileAsync(file);
    } catch {
        return { ok: false, message: "Could not read the selected file." };
    }

    if (checkImageDimensions) {
        try {
            const { width, height } = await readImageDimensions(dataUrl);
            if (width > maxDimension || height > maxDimension) {
                return { ok: false, message: `Image dimensions should be ${maxDimension} x ${maxDimension} pixels or smaller.` };
            }
        } catch {
            return { ok: false, message: "Upload a valid image file." };
        }
    }

    return { ok: true, previewUrl: generatePreview ? dataUrl : null };
}



export const handleDotAndCharatersRestrict = (
    e,
    isMinus = false,
    maxBeforeDecimal = Infinity,
    maxAfterDecimal = Infinity
) => {
    const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End",
    ];

    const value = e.target.value;
    const key = e.key;

    const isNumber = key >= "0" && key <= "9";
    const isDot = key === ".";
    const isMinusKey = key === "-";

    const minusAllowed = isMinus && isMinusKey && value.length === 0;

    if (allowedKeys.includes(key)) {
        return;
    }

    if (minusAllowed) {
        return;
    }

    if (!isNumber && !isDot) {
        e.preventDefault();
        return;
    }

    if (isDot) {
        if (value.includes(".")) {
            e.preventDefault();
            return;
        }

        if (value.length === 0) {
            e.preventDefault();
            return;
        }

        return;
    }

    const [beforeDecimal, afterDecimal = ""] = value.split(".");

    if (!value.includes(".") && beforeDecimal.length >= maxBeforeDecimal) {
        e.preventDefault();
        return;
    }

    if (value.includes(".") && afterDecimal.length >= maxAfterDecimal) {
        e.preventDefault();
        return;
    }

    if (beforeDecimal === "0" && !value.includes(".")) {
        e.preventDefault();
    }
};

export const underscoreFormatText = (value) => {
    return value ? value?.replace(/_/g, " ").toLowerCase() : "";
};


export const truncateMiddle = (str, front = 6, back = 6) => {
    if (!str) return "-";
    if (str.length <= front + back + 3) return str;
    return `${str.slice(0, front)}...${str.slice(-back)}`;
};

export const getPlanLevel = (type) => {
    const match = String(type ?? "").match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
};
